import { MonitorSmartphone } from 'lucide-react';

/**
 * E-Book statt Buch (03.11.2026). Der Betreiber: „Wir wählen bei der
 * VLB-Suche die digitale Version statt des physischen Buchs." E-Books
 * werden sehr, sehr selten bestellt — die Marke ist deshalb Koralle wie
 * eine Warnung, nicht Gold wie ein Hinweis.
 *
 * Ob ein Titel digital ist, entscheidet der Server (vlbIstDigital() in
 * api/lib/vlb_mapper.php, Fallstrick 15).
 */
export function DigitalMarke() {
  return (
    <span
      data-testid="digital-marke"
      className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded bg-coral-soft px-1.5 py-0.5 text-xs font-normal text-coral"
    >
      <MonitorSmartphone aria-hidden className="h-3 w-3" />
      E-Book · kein gedrucktes Buch
    </span>
  );
}
